/** All available workers' types */
export const EnumWorkersTypes = {
	operators: 'operators',
	suppliers: 'suppliers',
	staff: 'staff',
} as const;



/** All statuses values allowed for a worker */
export const EnumWorkersStatuses = {
	active: 'active',
	inactive: 'inactive',
} as const;
